import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Stale-asset guard: after a deploy, a browser holding the old index.html may request a
// JS/CSS chunk that no longer exists (404 → blank green screen). Reload once to pull the
// fresh build. A sessionStorage flag prevents reload loops if the problem isn't a stale asset.
function reloadOnceForStaleAsset() {
  if (sessionStorage.getItem("sms_chunk_reloaded")) return;
  sessionStorage.setItem("sms_chunk_reloaded", "1");
  window.location.reload();
}
window.addEventListener(
  "error",
  (e) => {
    const el = e?.target;
    if (el && (el.tagName === "SCRIPT" || el.tagName === "LINK")) reloadOnceForStaleAsset();
  },
  true, // capture phase — resource load errors don't bubble
);
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e?.reason?.message || "").toLowerCase();
  if (/loading chunk|chunkloaderror|dynamically imported module|importing a module/.test(msg)) {
    reloadOnceForStaleAsset();
  }
});
// If the app has run cleanly for a bit, the reload (if any) worked — clear the flag so a
// future deploy is allowed to auto-reload again.
setTimeout(() => sessionStorage.removeItem("sms_chunk_reloaded"), 8000);
